import { submit, destroy, reset } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as $ from 'jquery';
import { orderEditCancel, orderUpdate, orderCloseModal } from '../../../redux/actions/order/orderActions';
import { storeSettingLoad } from '../../../redux/actions/storeSettings/storeSettingActions';
import OrderForm from '../order/OrderForm';
import { useEffect } from 'react';

function OrderModal(props) {
  const { order, orderEditing, currentUser } = props;

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (order.store_id) {
      dispatch(storeSettingLoad({ filter: { store_id: order.store_id }, page: 1, rpp: 999999999, sort: 'position', direction: 'asc' }))
    }
  }, [order.store_id])

  useEffect(() => {
    if (!orderEditing) {
      $('#orderForm-modal').modal('hide');
    }
  }, [orderEditing])

  const handleRemoteSubmit = (formName) => {
    dispatch(submit(formName))
  }

  const handleOrderSubmit = (data) => {
    const payload = validateArr(data)
    dispatch(orderUpdate({ ...payload, current_user_id: currentUser.id }, { include: '*' }))
      // Failed remove leaves _destroy in form — clear it so next edit doesn't resend it
      .catch(() => {
        if (data.eyeglasses_attributes) dispatch(reset('orderEyeglassForm'))
      })
  }

  const validateArr = (data) => {
    if (!data.eyeglasses_attributes) return data

    // Drop empty lens type rows (BE requirement)
    const eyeglasses_attributes = data.eyeglasses_attributes.map((item) => ({
      ...item,
      lens_types_attributes: (item.lens_types_attributes || []).filter((lens) => lens.settings_eyeglass_lens_type_id),
    }))

    return { ...data, eyeglasses_attributes }
  }

  const handleOrderEditCancel = () => {
    dispatch(destroy('orderEyeglassForm'))
    dispatch(orderCloseModal(false))
    dispatch(orderEditCancel())
    const match = window.location.pathname.match(/^(\/order\/(all-orders|recent-orders|unfinished-orders|finalized-orders))\//);
    if (match) {
      history.replace(match[1])
    }
  }

  return (
    <div className="exam-setting-modal exam-modal">
      <div className="modal fade pr-0" id="orderForm-modal" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
        <div className="modal-dialog m-0" role="document">
          <div className="modal-content bg-light">
            {order.id &&
              <OrderForm
                onSubmit={handleOrderSubmit}
                onRemoteSubmit={handleRemoteSubmit}
                handleOrderEditCancel={handleOrderEditCancel}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const { order, auth } = state;
  return {
    order: order.order,
    orderEditing: order.editing,
    currentUser: auth.user,
  };
}

export default connect(mapStateToProps)(OrderModal);
